export function getRequestOptionDemoMode(key?: string) {
  return { isMock: !!getDemoMode(), decoratePathKey: key };
}

export function getDemoMode() {
  return sessionStorage.getItem('mode') === 'demo';
}
